module.exports = __webpack_public_path__ + "assets/banner-1c171c6ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/banner/banner-1.jpg
// module id = 975
// module chunks = 23